@if (!forceFallback() && displaySymbol(); as symbol) {
  @if (symbol.type === 'emoji') {
    <rt-emoji [emoji]="symbol.unicode" [size]="14" />
  }
  @if (symbol.type === 'icon') {
    <rt-icon-font [name]="symbol.name" [size]="'small'" />
  }
} @else {
  @if (fallbackIcon(); as icon) {
    <rt-icon [name]="icon" size="small"></rt-icon>
  }
}
